import { Route } from '@angular/router';
import { SignIn } from '../auth/pages/sign-in/sign-in.component';
import { Home } from '../home/home.component';
import { Layout } from '../../shared/layout/layout.component';
import { authGuard } from './guards/auth.guard';
import { CCRRListLayout } from '../ccrr-list-layout/ccrr-list-layout.component';
import { userDataGuard } from '../ccrr-list-layout/guards/user-data.guard';
import { Activation } from '../auth/pages/activation/activation-form.component';
import { ErrorComponent, schemaAccessGuard } from '@net3-multiplatform-client/libs';
import { tokenRequiredGuard } from './guards/token-required.guard';
import { ValidationEmailPage } from '../auth/pages/validation-email/validation-email.component';

export const appRoutes: Route[] = [
  {
    path: 'communities',
    canActivate: [authGuard('/signin')],
    children: [
      {
        path: '',
        canActivate: [userDataGuard],
        component: CCRRListLayout,
        data: { breadcrumb: 'Comunidades' }
      },
      {
        path: ':id',
        component: Layout,
        canActivate: [schemaAccessGuard],
        children: [
          {
            path: '',
            redirectTo: 'home',
            pathMatch: 'full',
          },
          {
            path: 'home',
            component: Home,
            data: { 
              breadcrumb: 'Inicio' ,
              active: false
            }
          },
          {
            path: 'irrigation-outlets',
            loadChildren: () => import('../irrigation-outlets/irrigation-outlets.routes').then(r => r.routes),
            data: { 
              breadcrumb: 'Tomas',
              active: false
            }
          },
          {
            path: 'sectors',
            loadChildren: () => import('../sectors/sectors.routes').then(r => r.routes),
            data: { 
              breadcrumb: 'Sectores',
              active: false
            }
          },
          {
            path: 'users',
            loadChildren: () => import('./../users/user.routes').then(r => r.routes),
            data: { 
              breadcrumb: 'Usuarios',
              active: false
            }
          },
          {
            path: 'irrigation-schedule',
            loadChildren: () => import('./../irrigation-schedule/irrigation-schedule.routes').then(r => r.routes),
            data: { breadcrumb: 'Previsión de riego' }
          },
          {
            path: 'history',
            loadComponent: () => import('../history/pages/history.component').then(m => m.HistoryPage),
            data: { 
              breadcrumb: 'Acumulados',
              active: false
            }
          },
          {
            path: 'sensors',
            loadComponent: () => import('../sensors/pages/sensors.component').then(m => m.SensorsPage),
            data: { 
              breadcrumb: 'Sensores',
              active: false
            }
          },
          {
            path: '**',
            redirectTo: 'home',
            pathMatch: 'full',
          },
        ],
      },
    ],
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: 'signin',
    component: SignIn,
  },
  {
    path: 'activation',
    component: Activation,
    canActivate: [tokenRequiredGuard()],
  },
  {
    path: 'validation',
    component: ValidationEmailPage,
    canActivate: [tokenRequiredGuard()],
  },
  {
    path: '**',
    redirectTo: 'communities',
    pathMatch: 'full',
  },
];
